import { render, staticRenderFns } from "./RiskLogsPage.vue?vue&type=template&id=7d1d0c4b&scoped=true"
import script from "./RiskLogsPage.vue?vue&type=script&lang=ts"
export * from "./RiskLogsPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d1d0c4b",
  null
  
)

export default component.exports